import "@/App.css";
import { ReactLenis } from "lenis/react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Site from "@/pages/Site";
import Admin from "@/pages/Admin";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import FAQPage from "@/pages/FAQPage";
import ContactPage from "@/pages/ContactPage";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import ServicePage from "@/pages/ServicePage";
import CityPage from "@/pages/CityPage";
import NotFound from "@/pages/NotFound";
import VinDecoder from "@/pages/VinDecoder";
import BookPage from "@/pages/BookPage";

export function AppRoutes() {
  return (
        <Routes>
          <Route path="/" element={<Site />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/free-vin-decoder" element={<VinDecoder />} />
          <Route path="/book" element={<BookPage />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/services/:slug" element={<ServicePage />} />
          <Route path="/vin-verification/:slug" element={<CityPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
  );
}

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, duration: 1.1, smoothWheel: true }}>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </ReactLenis>
  );
}

export default App;
